/**
 * 设置通用的 分页参数
 * @param {Vue} Vue
 */
let install = (Vue) => {
  if (install.installed) return
  Vue.mixin({
    data () {
      return {
        pager: {
          total: 0,
          curPage: 1,
          pageSize: 10
        }
      }
    },
    methods: {
      pageSizeChange (pageSize, callback) {
        this.pager.pageSize = pageSize
        if (callback && typeof callback === 'function') {
          callback()
        }
      },
      curPageChange (curPage, callback) {
        this.pager.curPage = curPage
        if (callback && typeof callback === 'function') {
          callback()
        }
      }
    }
  })
}
export default install



// WEBPACK FOOTER //
// ./src/cdpBase/mixins/pager.js